import { Entity } from "../../Entity";
import LanguageFactory from "../../Factories/LanguageFactory";
import { FactoryInterface } from "../../FactoryInterface";
import { LanguageInterface } from "./LanguageInterface";

class Language extends Entity implements LanguageInterface {

  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return LanguageFactory;
  }

  get iso(): string {
    return this.data.iso;
  }
}

export { Language }
